export default __webpack_public_path__ + "static/media/06_kuna_info-min.bab446cd.jpg";